export const EXTENSION_AUTH_REDIRECT_URI_KEY = "extensionAuthRedirectUri";
export const EXTENSION_AUTH_SOURCE_KEY = "extensionAuthSource";

const CHROMIUM_APP_REDIRECT_PATTERN =
  /^https:\/\/[a-z0-9-]+\.chromiumapp\.org(?:\/.*)?$/i;

export function isValidExtensionRedirectUri(
  value: string | null | undefined,
): boolean {
  if (!value) {
    return false;
  }
  try {
    const url = new URL(value);
    return CHROMIUM_APP_REDIRECT_PATTERN.test(url.origin + url.pathname);
  } catch {
    return false;
  }
}
